module.exports = "https://static.weeecdn.net/mweb/_next/static/images/intro-d2d383b2cce073026bfbcef93a8687ec.png";